<mat-card-content>
  <div style="min-height: 4px">
    <app-loading [isCircle]="false" [hasLoaded]="!areasLoading"></app-loading>
  </div>
  @if (!!areas?.length) {
    <div style="display: flex; justify-content: flex-start">
      @for (a of areas; track $index) {
        <div
          id="area"
          style="height: 120px; padding-right: 1rem"
          [attr.data-test]="'area'"
          [attr.data-testid]="a.title">
          <strong class="area-title">{{ a.title }}</strong
          ><br />
          @if (a.thumbUrl) {
            <img class="area-thumb" [src]="a.thumbUrl" alt="geofence area thumbnail" />
          }
        </div>
      }
    </div>
  }

  @if (!!areas?.length && !!alert?.recipients?.featureLayers?.length) {
    <div>
      @for (layer of alert?.recipients?.featureLayers; track $index) {
        <div style="padding-top: 0.5rem" [attr.data-test]="'feature-layer'" [attr.data-testid]="layer.Name">
          <strong class="layer-title">{{ layer.Name }}:</strong>
          <span
            ><br />
            &nbsp; {{ 'RecipientCount' | translate: locale.language }}: {{ getLayerRecipientCount(layer) }}</span
          >
          @if (isGroupFilteringPermitted) {
            <span
              ><br />
              &nbsp; {{ getLayerFilterText(layer) }}</span
            >
          }
        </div>
      }
    </div>
  }
</mat-card-content>
